// No-op module to which other modules are conditionally redirected in order to
// disable them.
export default false;
